
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 10.187a4.103 4.103 0 00-3.452-4.046v-2.34c0-1.06-.668-1.801-1.625-1.801-.28 0-.569.066-.858.196L8.41 6.09H3.37A2.373 2.373 0 001 8.46v3.452c0 .829.428 1.56 1.074 1.983l1.016 5.08c.248 1.24 1.433 2.211 2.697 2.211a2.373 2.373 0 002.37-2.37v-4.534h.253l8.655 3.895c.289.13.577.196.858.196h0c.471 0 .894-.188 1.192-.53.283-.326.433-.765.433-1.271v-2.34A4.103 4.103 0 0023 10.186zM2.29 8.461c0-.596.484-1.081 1.08-1.081h4.534v5.614H3.37a1.083 1.083 0 01-1.08-1.081V8.46zm4.578 10.356c0 .596-.485 1.081-1.081 1.081-.638 0-1.308-.549-1.433-1.174l-.888-4.44h3.402v4.533zm11.391-2.244c0 .187-.041.338-.117.425-.032.037-.09.087-.219.087a.827.827 0 01-.329-.082l-8.401-3.78V7.151l8.401-3.78a.83.83 0 01.33-.083c.277 0 .335.279.335.512v12.772h0zm1.29-3.653V7.454a2.812 2.812 0 012.162 2.733c0 1.326-.925 2.44-2.163 2.733z","fill":"#989AB3","stroke":"#989AB3","stroke-width":".6"}})])
          )
        }
      }
    